import * as S from './styles';
import PanelOptionMixin from '@/components/Dashboard/common/WidgetSettingPanel/options/mixin';
import SecondPanelContent from '@/components/Dashboard/common/WidgetSettingPanel/options/filterWidgetOptions/dropdownOptions/secondPanelContent';
import Dropdown from '@/components/Common/Dropdown';
import {
    DefaultDropdownBox,
    SelectedBox,
} from '@/components/Common/DropdownBox';
import MultiInputField from '@/components/Common/MultiInputField';
import Draggable from 'vuedraggable';
import dragMixin from '@/mixins/drag';
import channelIconMixin from '@/mixins/channelIcons';

import FilterIcon from '@svgIcons/filter.svg';
import MoveIcon from '@svgIcons/move.svg';
import CloseIcon from '@svgIcons/close.svg';
import EyeIcon from '@svgIcons/eye.svg';
import InfoIcon from '@svgIcons/info_line.svg';
import BulletPointIcon from '@svgIcons/bullet-point.svg';
import { NoteWrapper, NoteText } from './secondPanelContent/styles';
import NextIcon from '@svgIcons/next.svg';
import RingLoader from '@/components/Common/RingLoader';

import * as R from 'ramda';
import { changeOrder, indexById, isValueExist } from '@/utils/utils';
import { NoItemMessage } from '@/components/Dashboard/common/WidgetSettingPanel/options/filterWidgetOptions/styles';
import Dialog from '@/components/Common/Dialog';
import { ActionButton } from '@/components/Common/Dialog';
import { Tooltip } from 'ant-design-vue';
import { FILTER_KEYS, SUB_CHANNEL_FILTER_LIST } from '@/utils/consts';
import {
    DEFAULT_OPERATOR_MAP,
    FIELD_OPTIONS,
    OPERATOR_LIST_MAP,
    OPERATOR_LIST_TYPES,
    VALUE_INPUT_TYPE_MAP,
    INPUT_TYPES,
} from '@/components/Dashboard/common/SearchBar/filters/const';
import {
    getRefinedField,
    getRefinedOperator,
    getRefinedValues,
} from '@/components/Common/FilterInfo/utils';
import {
    COMPLEMENT_OPERATOR_MAP,
    NOT_OPERATOR,
} from '@/components/Dashboard/common/Filter/const';

import { mapGetters, mapState } from 'vuex';
import { DashboardService } from '@/services';
import debounce from 'lodash/debounce';
import {
    checkIsHidden,
    refineChannel,
    refineChannelIconName,
    mappingActivated,
    refineSourceName,
    getChannelOptionGroupId,
} from '@/utils/dashboard';
import { refineChannelLogoSrc } from '@/utils/account';
import { getChannelFilterName, getChannelName } from '@/utils/channelName';
import {
    resolveTeamspaceAllowedChannelIds,
    resolveTeamspaceAllowedAssetIds,
} from '@/utils/filter';
import ChannelCheckbox from '@/components/Dashboard/common/SearchBar/filters/channel/checkbox';
import { refineAccountName } from '@/components/Dashboard/common/SearchBar/filters/helper';
import { refineRawText } from '@/utils/translator';
import AdAccountCheckbox from '@/components/Dashboard/common/SearchBar/filters/adAccount/checkbox';
import {
    filterDimensionsByGroup,
    getFilterWidgetAvailableLabelKey,
    isFilterWidgetBreakdownLabel,
    normalizeFilterWidgetAvailableLabel,
} from '@/components/Dashboard/common/WidgetSettingPanel/utils';
import {
    FILTER_WIDGET_FIELD_VALUE_SUBTYPE,
    FILTER_WIDGET_LABEL_SUBTYPE,
    getConditionFieldOptions,
    getChannelOptions,
    makeDefaultCondition,
} from './dropdownConfig';

const SEARCH_DEBOUNCE_MS = 350;
const PREVIEW_LIMIT = 50;
const PREVIEW_SCROLL_THRESHOLD = 32;
const { TITLE, STATUS, CHANNEL, ID, AD_ACCOUNT_ID } = FILTER_KEYS;
const CONDITION_DROPDOWN_STYLE = {
    menuItemHeight: '36px',
    menuItemPadding: '0 12px',
};

const DROPDOWN_GAP = 4;
const DROPDOWN_HEIGHT = 342;
const RESERVED_CHANNEL_GROUP_IDS = ['marketing', 'organic'];

const toConditionDataSources = R.compose(
    R.uniqBy(R.prop('channelId')),
    R.sortBy(R.prop('channel'))
);

const toConditionChannels = R.compose(
    R.uniq,
    R.flatten,
    R.map((account) => {
        const channel = refineChannel(account);
        return channel === 'google' ? SUB_CHANNEL_FILTER_LIST : channel;
    })
);

export default {
    mixins: [
        PanelOptionMixin,
        dragMixin({ cursorNormal: 'grab' }),
        channelIconMixin,
    ],
    name: 'DropdownOptions',
    props: {
        availableLabels: {
            type: Array,
            default: () => [],
        },
        handleUpdateAvailableLabels: {
            type: Function,
            default: () => {},
        },
        handleUpdate: {
            type: Function,
            default: () => {},
        },
        handleUpdatePatch: {
            type: Function,
            default: () => {},
        },
        subType: {
            type: String,
            default: FILTER_WIDGET_LABEL_SUBTYPE,
        },
        groupId: {
            type: String,
            default: undefined,
        },
        by: {
            type: Object,
            default: undefined,
        },
        condition: {
            type: Object,
            default: undefined,
        },
        values: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            active: false,
            secondPanelOutsideClickActive: true,
            showDialog: false,
            pendingCloseProceed: null,
            originalOptions: {},
            breakdownLabelsById: {},
            selectedLabelsByBreakdownId: {},
            breakdownLabelLoadedMap: {},
            breakdownLabelLoadingMap: {},
            breakdownLabelRequestMap: {},
            searchQuery: '',
            searchBreakdowns: [],
            searchBreakdownLabelsById: {},
            searchRequestId: 0,
            isSearchLoading: false,
            conditionValueVisible: false,
            conditionAdAccountList: [],
            labelModeSnapshot: null,
            previewLoading: false,
            previewLoadingMore: false,
            previewValues: [],
            previewTotal: 0,
            previewHasMore: false,
            previewRequestId: 0,
            showConditionBuilder: false,
            showPreviewValues: false,
            channelVisible: false,
            nestedChannelVisible: {},
            byVisible: false,
            nestedByVisible: {},
            conditionFieldVisible: false,
            conditionOperatorVisible: false,
            conditionStatusVisible: false,
            dropdownPosition: {},
        };
    },
    watch: {
        panelVisibility(visible) {
            if (visible) {
                this.originalOptions = {
                    availableLabels: this.availableLabels,
                    subType: this.subType,
                    groupId: this.groupId,
                    by: this.by,
                    condition: this.condition,
                    values: this.values,
                };
                this.showConditionBuilder = Boolean(this.condition);
                this.showPreviewValues = false;
            }
            this.$emit('outsideClick:active', !visible);
            if (visible) {
                this.sanitizeConditionValuesForDatasourceScope();
                this.debouncedFetchPreview?.();
            } else {
                this.previewLoading = false;
            }
        },
        groupId: {
            immediate: true,
            handler() {},
        },
        availableLabels: {
            handler() {
                this.ensureSelectedBreakdownLabelsLoaded();
            },
            immediate: true,
        },
        condition(nextCondition) {
            if (!this.panelVisibility) {
                return;
            }

            this.showConditionBuilder = Boolean(nextCondition);
            this.sanitizeConditionValuesForDatasourceScope();
        },
        effectiveFilteredAdAccountIds() {
            if (!this.panelVisibility) {
                return;
            }

            this.sanitizeConditionValuesForDatasourceScope();
        },
    },
    computed: {
        ...mapState('newDashboard', [
            'dimensions',
            'tableAdAccounts',
            'teamspaceAllowedChannelIds',
            'teamspaceAllowedAssetIds',
        ]),
        ...mapGetters('newDashboard', [
            'currentView',
            'currentViewConfig',
            'tableAdAccountsByGroupId',
        ]),
        ...mapGetters('user', ['userLang', 'account']),
        /**
         * `null` = unfiltered, `string[]` = allowed channelIds (`[]` = allow
         * nothing).
         */
        effectiveFilteredAdAccountIds() {
            return resolveTeamspaceAllowedChannelIds(this.teamspaceAllowedChannelIds);
        },
        /**
         * `null` = unfiltered, `number[]` = allowed assetIds (`[]` = allow
         * nothing).
         */
        effectiveFilteredAssetIds() {
            const resolved = resolveTeamspaceAllowedAssetIds(
                this.teamspaceAllowedAssetIds
            );

            return resolved === null ? null : resolved.map(Number);
        },
        filteredTableAdAccounts() {
            if (this.effectiveFilteredAssetIds === null) {
                return this.tableAdAccounts || [];
            }

            return R.filter(
                (acc) =>
                    this.effectiveFilteredAssetIds.includes(Number(acc.assetId)),
                this.tableAdAccounts || []
            );
        },

        isTemplateView() {
            return this.currentView?.isTemplate || false;
        },
        isFieldValueFilterWidgetEnabled() {
            return this.account?.meta?.allowFieldValueFilterWidget === true;
        },
        isLabelMode() {
            return (
                !this.isFieldValueFilterWidgetEnabled ||
                this.subType === FILTER_WIDGET_LABEL_SUBTYPE
            );
        },
        effectiveBy() {
            if (this.isLabelMode) {
                return { type: 'label' };
            }

            return this.isSelectedGroupAvailable ? this.by : undefined;
        },
        hasSelectedBy() {
            return Boolean(this.effectiveBy);
        },
        availableChannelGroupIds() {
            return R.compose(
                R.uniq,
                R.flatten,
                R.map((option) => [
                    option.groupId,
                    ...R.pluck('groupId', option.children || []),
                ])
            )(this.channelOptions || []);
        },
        isSelectedGroupAvailable() {
            return this.availableChannelGroupIds.includes(this.groupId);
        },
        channelOptions() {
            const channelAccountsByTopGroup = R.groupBy(
                getChannelOptionGroupId,
                this.filteredTableAdAccounts || []
            );
            return R.sortWith(
                [
                    R.descend((option) => option.groupId === 'marketing'),
                    R.descend((option) => option.groupId === 'organic'),
                    R.descend((option) => !option.children?.length),
                    R.ascend((option) =>
                        String(option.text || '').toLowerCase()
                    ),
                ],
                getChannelOptions(
                    this.filteredTableAdAccounts || [],
                    this.groupTranslator
                )
                    .filter((groupId) => {
                        if (RESERVED_CHANNEL_GROUP_IDS.includes(groupId)) {
                            return true;
                        }

                        const accounts = R.propOr(
                            [],
                            groupId,
                            channelAccountsByTopGroup
                        );
                        const primaryAccount = R.head(accounts);

                        return !primaryAccount?.isFreeFormat;
                    })
                    .map((groupId) => {
                        const accounts = R.propOr(
                            [],
                            groupId,
                            channelAccountsByTopGroup
                        );
                        const primaryAccount = R.head(accounts);
                        const isReservedChannelGroup =
                            RESERVED_CHANNEL_GROUP_IDS.includes(groupId);

                        if (
                            isReservedChannelGroup ||
                            !primaryAccount?.isFreeFormat
                        ) {
                            return {
                                key: groupId,
                                groupId,
                                text: this.getChannelGroupLabel(groupId),
                                Icon: this.getChannelOptionIcon(
                                    groupId,
                                    primaryAccount
                                ),
                            };
                        }

                        return {
                            key: groupId,
                            groupId,
                            text: this.getChannelGroupLabel(
                                groupId,
                                primaryAccount
                            ),
                            Icon: this.getChannelOptionIcon(
                                groupId,
                                primaryAccount
                            ),
                            children: R.sortBy(
                                ({ text }) => String(text || '').toLowerCase(),
                                accounts.map((account) => ({
                                    key: account.groupId,
                                    groupId: account.groupId,
                                    text: refineAccountName.call(this, account),
                                    Icon: this.getChannelOptionIcon(
                                        account.groupId,
                                        account
                                    ),
                                }))
                            ),
                        };
                    })
            );
        },
        byOptions() {
            const allowChannelBy = ['marketing', 'organic'].includes(
                this.groupId
            );
            const options = [
                ...(this.groupId === 'marketing'
                    ? [{ type: 'field', field: TITLE, level: 'campaign' }]
                    : []),
                ...(allowChannelBy ? [{ type: 'field', field: CHANNEL }] : []),
                ...(this.groupId === 'marketing'
                    ? [{ type: 'field', field: ID, level: 'campaign' }]
                    : []),
                { type: 'field', field: AD_ACCOUNT_ID },
            ].map((by) => ({
                by,
                text: this.formatByOption(by),
            }));

            if (
                this.effectiveBy &&
                !options.some(({ by }) => R.equals(by, this.effectiveBy))
            ) {
                return [
                    ...options,
                    {
                        by: this.effectiveBy,
                        text: this.formatByOption(this.effectiveBy),
                    },
                ];
            }

            return options;
        },
        groupedByOptions() {
            return this.byOptions.reduce((acc, option) => {
                const field = option.by?.field;

                if (option.by?.type === 'label') {
                    acc.push({
                        key: 'label',
                        text: option.text,
                        by: option.by,
                    });
                    return acc;
                }

                if (!field || !option.by?.level) {
                    acc.push({
                        key: option.text,
                        text: option.text,
                        by: option.by,
                    });
                    return acc;
                }

                const existing = acc.find((item) => item.key === field);

                if (existing) {
                    existing.children.push({
                        text: this.levelTranslator(field, option.by.level),
                        by: option.by,
                    });
                    return acc;
                }

                acc.push({
                    key: field,
                    text: this.fieldTranslator(field),
                    children: [
                        {
                            text: this.levelTranslator(field, option.by.level),
                            by: option.by,
                        },
                    ],
                });

                return acc;
            }, []);
        },
        selectedChannelLabel() {
            if (!this.groupId || !this.isSelectedGroupAvailable) {
                return '';
            }

            return this.groupTranslator(this.groupId);
        },
        selectedByLabel() {
            if (!this.effectiveBy) {
                return '';
            }

            return this.formatByOption(this.effectiveBy);
        },
        /**
         * Candidate accounts for the condition builder, before the
         * teamspace/current-view datasource scope is applied.
         *
         * Everything here (group membership, the marketing mapped/blended
         * additions, the template-view isFreeFormat rule) is a domain rule
         * unrelated to the scope, so both variants share it. Same split as
         * `sourceOptions` / `sourceOptionsIgnoringScope` in the panel root.
         */
        conditionAccountsIgnoringScope() {
            const selectedGroupId = this.groupId;

            if (!selectedGroupId) {
                return [];
            }

            let accounts = R.propOr(
                [],
                selectedGroupId,
                this.tableAdAccountsByGroupId
            );

            if (selectedGroupId === 'marketing') {
                const mappedAccounts = R.filter(
                    mappingActivated,
                    this.tableAdAccounts
                );
                const blendedAccounts = R.filter(
                    (acc) => R.pathEq(['settings', 'isFullJoin'], true, acc),
                    this.tableAdAccounts
                );
                accounts = R.concat(
                    accounts,
                    R.concat(mappedAccounts, blendedAccounts)
                );
            }

            // Apply isFreeFormat filter in template view (match React behavior)
            if (this.isTemplateView) {
                accounts = R.filter((acc) => !acc.isFreeFormat, accounts);
            }

            return accounts;
        },
        conditionAccounts() {
            const {
                conditionAccountsIgnoringScope,
                effectiveFilteredAssetIds,
            } = this;

            // Apply teamspace/current-view datasource filters if present
            if (effectiveFilteredAssetIds === null) {
                return conditionAccountsIgnoringScope;
            }

            return R.filter(
                (acc) => effectiveFilteredAssetIds.includes(Number(acc.assetId)),
                conditionAccountsIgnoringScope
            );
        },
        conditionDataSourceList() {
            return toConditionDataSources(this.conditionAccounts);
        },
        conditionDataSourceListIgnoringScope() {
            return toConditionDataSources(this.conditionAccountsIgnoringScope);
        },
        conditionChannelList() {
            return toConditionChannels(this.conditionAccounts);
        },
        conditionChannelListIgnoringScope() {
            return toConditionChannels(this.conditionAccountsIgnoringScope);
        },
        breakdownList() {
            if (!isValueExist(this.dimensions)) {
                return [];
            }

            return R.sortBy(
                R.compose(R.toLower, R.propOr('', 'name')),
                filterDimensionsByGroup(
                    this.dimensions.filter(R.prop('id')),
                    this.groupId,
                    this.tableAdAccountsByGroupId
                )
            );
        },
        labelList() {
            return R.flatten(Object.values(this.breakdownLabelsById));
        },
        selectedLabelList() {
            return R.flatten(Object.values(this.selectedLabelsByBreakdownId));
        },
        labelsById() {
            const { labelList, selectedLabelList } = this;

            const mergedLabels = [
                ...(labelList || []),
                ...(selectedLabelList || []),
            ];

            if (!isValueExist(mergedLabels)) {
                return {};
            }

            return indexById(mergedLabels);
        },
        panelVisibility() {
            return this.isSecondPanelOpen;
        },
        isOptionsChanged() {
            const {
                originalOptions,
                availableLabels,
                subType,
                groupId,
                by,
                condition,
                values,
            } = this;
            const currentOptions = {
                availableLabels,
                subType,
                groupId,
                by,
                condition,
                values,
            };
            return !R.equals(originalOptions, currentOptions);
        },
        normalizedSearchQuery() {
            return this.searchQuery?.trim() || '';
        },
        isSearchActive() {
            return Boolean(this.normalizedSearchQuery);
        },
        normalizedAvailableLabels() {
            return R.uniqBy(
                getFilterWidgetAvailableLabelKey,
                (this.availableLabels || []).map(
                    normalizeFilterWidgetAvailableLabel
                )
            );
        },
        selectedBreakdownIdsSet() {
            return new Set(
                this.normalizedAvailableLabels
                    .filter(isFilterWidgetBreakdownLabel)
                    .map((label) => String(label.id))
            );
        },
        selectedCount() {
            return this.normalizedAvailableLabels.reduce((count, label) => {
                if (isFilterWidgetBreakdownLabel(label)) {
                    const breakdown = this.breakdownById?.[String(label.id)];
                    return count + (breakdown?.labelsCount || 0);
                }

                const breakdownId = label?.customBreakdownId;
                const isBreakdownLoaded = !isValueExist(breakdownId)
                    ? true
                    : this.breakdownLabelLoadedMap?.[String(breakdownId)] ===
                      true;

                if (!isBreakdownLoaded) {
                    return count + 1;
                }

                return this.getLabelById(label.id) ? count + 1 : count;
            }, 0);
        },
        fieldValueSummaryLabel() {
            if (this.isLabelMode || !this.effectiveBy) {
                return '';
            }

            return this.formatByOption(this.effectiveBy);
        },
        maxSelectedLabels() {
            return 10000;
        },
        displayBreakdownList() {
            return this.isSearchActive
                ? this.searchBreakdowns
                : this.breakdownList;
        },
        breakdownById() {
            return indexById(this.breakdownList || []);
        },
        displayBreakdownLabelsById() {
            return this.isSearchActive
                ? this.searchBreakdownLabelsById
                : this.breakdownLabelsById;
        },
        selectedCountByBreakdownId() {
            return this.normalizedAvailableLabels.reduce((acc, label) => {
                const breakdownId = label?.customBreakdownId;
                if (
                    isFilterWidgetBreakdownLabel(label) ||
                    !isValueExist(breakdownId)
                ) {
                    return acc;
                }

                const key = String(breakdownId);
                const isBreakdownLoaded =
                    this.breakdownLabelLoadedMap?.[key] === true;

                if (isBreakdownLoaded && !this.labelsById?.[label.id]) {
                    return acc;
                }

                const prev = acc[key] || 0;
                acc[key] = prev + 1;
                return acc;
            }, {});
        },
        labelTotalByBreakdownId() {
            return Object.entries(this.breakdownLabelsById || {}).reduce(
                (acc, [breakdownId, labels]) => {
                    acc[breakdownId] = Array.isArray(labels)
                        ? labels.length
                        : 0;
                    return acc;
                },
                {}
            );
        },
        categoryCheckStateById() {
            return (this.breakdownList || []).reduce((acc, breakdown) => {
                const breakdownId = String(breakdown.id);
                if (this.selectedBreakdownIdsSet.has(breakdownId)) {
                    acc[breakdownId] = 'checked';
                    return acc;
                }

                const selectedCount =
                    this.selectedCountByBreakdownId[breakdownId] || 0;
                const isLoaded =
                    this.breakdownLabelLoadedMap?.[breakdownId] === true;

                if (!isLoaded) {
                    acc[breakdownId] =
                        selectedCount > 0 ? 'indeterminate' : 'unchecked';
                    return acc;
                }

                const total = this.labelTotalByBreakdownId[breakdownId] ?? 0;
                if (total === 0 || selectedCount === 0) {
                    acc[breakdownId] = 'unchecked';
                    return acc;
                }

                acc[breakdownId] =
                    selectedCount >= total ? 'checked' : 'indeterminate';
                return acc;
            }, {});
        },
        conditionFieldOptions() {
            return getConditionFieldOptions(this.effectiveBy);
        },
        defaultCondition() {
            return makeDefaultCondition(this.effectiveBy);
        },
        effectiveCondition() {
            return this.condition || this.defaultCondition;
        },
        selectedConditionField() {
            const refinedField = getRefinedField(this.effectiveCondition);
            const level = this.effectiveCondition?.level;

            return this.conditionFieldOptions.find(
                (option) =>
                    option.field === refinedField && option.level === level
            );
        },
        selectedConditionFieldLabel() {
            if (!this.selectedConditionField) {
                return '';
            }

            return this.formatByOption({
                type: 'field',
                field: this.selectedConditionField.field,
                level: this.selectedConditionField.level,
            });
        },
        conditionOperatorOptions() {
            const refinedField =
                this.selectedConditionField?.field ||
                getRefinedField(this.effectiveCondition);

            if (!refinedField) {
                return [];
            }

            if (
                refinedField === TITLE &&
                this.selectedConditionField?.level === 'campaign'
            ) {
                return Object.values(OPERATOR_LIST_TYPES.STARTS || {});
            }

            return Object.values(OPERATOR_LIST_MAP[refinedField] || {});
        },
        selectedConditionOperator() {
            return this.condition ? getRefinedOperator(this.condition) : '';
        },
        selectedConditionValues() {
            return getRefinedValues(this.condition || {});
        },
        conditionValueInputType() {
            const refinedField =
                this.selectedConditionField?.field ||
                getRefinedField(this.effectiveCondition);

            if (
                refinedField === ID &&
                this.selectedConditionField?.level === 'campaign'
            ) {
                return VALUE_INPUT_TYPE_MAP[ID];
            }

            return VALUE_INPUT_TYPE_MAP[refinedField];
        },
        statusValueOptions() {
            return Object.values(
                R.pathOr({}, [STATUS, 'value'], FIELD_OPTIONS)
            );
        },
        marketingAdAccountOptions() {
            return (this.tableAdAccounts || []).filter(
                (account) =>
                    mappingActivated(account) ||
                    account?.groupId === 'marketing'
            );
        },
        /**
         * The stored condition narrowed to the teamspace scope, for the
         * preview request only. Mirrors react's
         * `scopeConditionToDatasourceScope` in
         * `FilterWidget/hooks/useFieldValueFilterWidget.tsx`, which pins this
         * endpoint's contract with specs.
         *
         * Request-side only — the result never goes back into the widget.
         * D-A' keeps `condition` exactly as the user saved it (that is why
         * `sanitizeConditionValuesForDatasourceScope` validates against the
         * unscoped candidates), so the narrowing that used to fall out of
         * that pruning has to happen here instead, on the way out.
         *
         * `matchesNothing` means no stored value is in scope, so the caller
         * must skip the request rather than send the predicate with an empty
         * `values`: an empty `values` reads as "no predicate" and would offer
         * the unscoped candidate pool (fail-open).
         */
        scopedPreviewCondition() {
            const { condition, effectiveFilteredAdAccountIds } = this;
            const unchanged = { condition, matchesNothing: false };

            /**
             * ★ null-widening trap. `null` means unfiltered, not "allows
             * nothing" — there is no scope to apply, so intersecting at all
             * is wrong here. React short-circuits the same case before
             * narrowing (`useFieldValueFilterWidget.tsx:145-147`) because its
             * `teamspaceDatasourceIds` widens `null` to `[]`; ours collapses
             * the same way whenever a list cannot speak about the field.
             */
            if (effectiveFilteredAdAccountIds === null) {
                return unchanged;
            }

            const values = getRefinedValues(condition || {});

            /**
             * No condition, or one that pins no values: nothing to narrow.
             * Not the same as "nothing is in scope".
             */
            if (!condition || !values.length) {
                return unchanged;
            }

            /**
             * Both scoped lists derive from `tableAdAccounts`; before it
             * lands they are empty, and narrowing against them would read as
             * "nothing is in scope" and drop the preview of a panel that is
             * merely still loading. Leave the condition alone until then.
             */
            if (!isValueExist(this.tableAdAccounts)) {
                return unchanged;
            }

            const field = getRefinedField(condition);
            const validValues =
                field === AD_ACCOUNT_ID
                    ? this.conditionDataSourceList.map(R.prop('channelId'))
                    : field === CHANNEL
                    ? this.conditionChannelList
                    : null;

            // A field the scope cannot speak about — narrowing would be a guess.
            if (!validValues) {
                return unchanged;
            }

            const validValueSet = new Set(validValues.map(String));
            const nextValues = values.filter((value) =>
                validValueSet.has(String(value))
            );

            if (nextValues.length === values.length) {
                return unchanged;
            }

            if (!nextValues.length) {
                return { condition, matchesNothing: true };
            }

            return {
                condition: { ...condition, values: nextValues },
                matchesNothing: false,
            };
        },
        previewRequestPayload() {
            const viewId = R.prop('id', this.currentView);
            if (this.isLabelMode || !viewId || !this.groupId || !this.effectiveBy) {
                return null;
            }

            const { condition: scopedCondition, matchesNothing } =
                this.scopedPreviewCondition;

            /**
             * Every value the widget pins is out of scope, so no candidate can
             * qualify. `fetchPreview` skips on a null payload — that is the
             * point: sending the request without the predicate would list the
             * unscoped pool instead of nothing.
             */
            if (matchesNothing) {
                return null;
            }

            const condition = this.selectedConditionValues.length
                ? scopedCondition
                : undefined;

            return {
                viewId,
                groupId: this.groupId,
                by: this.effectiveBy,
                condition,
                limit: PREVIEW_LIMIT,
                offset: 0,
            };
        },
        previewRequestKey() {
            return JSON.stringify(this.previewRequestPayload || null);
        },
        previewNames() {
            return (this.previewValues || [])
                .map((value) => {
                    const rawValue = value?.id ?? value?.value;
                    const text = this.getConditionValueLabel(
                        this.effectiveBy?.field,
                        rawValue
                    );
                    if (!text) return null;

                    const icon = this.getConditionValueIcon(
                        this.effectiveBy?.field,
                        rawValue
                    );

                    return {
                        key: rawValue || text,
                        text,
                        icon,
                    };
                })
                .filter(Boolean);
        },
    },
    created() {
        this.debouncedSearch = debounce(
            (query) => this.performLabelSearch(query),
            SEARCH_DEBOUNCE_MS
        );
        this.debouncedFetchPreview = debounce(
            () => this.fetchPreview(),
            SEARCH_DEBOUNCE_MS
        );
    },
    mounted() {
        document.addEventListener(
            'mousedown',
            this.handleConditionValueOutsideClick
        );
        document.addEventListener(
            'scroll',
            this.handleConditionDropdownClose,
            true
        );
    },
    beforeDestroy() {
        this.debouncedSearch?.cancel();
        this.debouncedFetchPreview?.cancel();
        document.removeEventListener(
            'mousedown',
            this.handleConditionValueOutsideClick
        );
        document.removeEventListener(
            'scroll',
            this.handleConditionDropdownClose,
            true
        );
    },
    methods: {

        formatFallbackGroupLabel(groupId) {
            if (!groupId) {
                return '';
            }

            const aliasMap = {
                fileFromEmail: 'File from Email',
                googleSpreadSheet: 'Google Sheets',
            };

            if (aliasMap[groupId]) {
                return aliasMap[groupId];
            }

            return groupId
                .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
                .replace(/[_-]+/g, ' ')
                .replace(/\s+/g, ' ')
                .trim()
                .replace(/\b\w/g, (char) => char.toUpperCase());
        },
        getChannelGroupLabel(groupId, accountOverride) {
            if (groupId === 'marketing' || groupId === 'organic') {
                return this.$t(`FILTERS.group_set_${groupId}`);
            }

            const account =
                accountOverride ||
                R.head(R.propOr([], groupId, this.tableAdAccountsByGroupId)) ||
                {};
            const displayName =
                this.userLang === 'ko'
                    ? account.displayChannelNameKR || account.displayChannelName
                    : account.displayChannelName;

            return (
                displayName ||
                getChannelFilterName.call(
                    this,
                    groupId,
                    getChannelName.call(this, groupId, '')
                ) ||
                this.formatFallbackGroupLabel(groupId) ||
                groupId
            );
        },
        groupTranslator(groupId) {
            switch (groupId) {
                case 'marketing':
                case 'organic':
                    return this.$t(`FILTERS.group_set_${groupId}`);
                case 'googleAnalytics4': {
                    const accounts = R.propOr(
                        [],
                        groupId,
                        this.tableAdAccountsByGroupId
                    );
                    const account = R.head(accounts) ?? {};

                    return (
                        (this.userLang === 'ko'
                            ? account.displayChannelNameKR ||
                              account.displayChannelName
                            : account.displayChannelName) || groupId
                    );
                }
                default: {
                    const accounts = R.propOr(
                        [],
                        groupId,
                        this.tableAdAccountsByGroupId
                    );
                    const account = R.head(accounts) ?? {};
                    const displayName =
                        this.userLang === 'ko'
                            ? account.displayChannelNameKR ||
                              account.displayChannelName
                            : account.displayChannelName;

                    if (account?.isFreeFormat) {
                        return (
                            refineSourceName(account) ||
                            account.title ||
                            account.name ||
                            groupId
                        );
                    }

                    return (
                        displayName ||
                        getChannelFilterName.call(
                            this,
                            groupId,
                            getChannelName.call(this, groupId, '')
                        ) ||
                        this.formatFallbackGroupLabel(groupId) ||
                        refineSourceName(account) ||
                        groupId
                    );
                }
            }
        },
        fieldTranslator(field) {
            return this.$t(`FILTERS.${field}`);
        },
        levelTranslator(field, level) {
            return this.$t(`FILTERS.${field}_option_${level}`);
        },
        formatByOption(by) {
            if (!by) {
                return '';
            }

            if (by.type === 'label') {
                return this.fieldTranslator(FILTER_KEYS.LABEL);
            }

            const fieldLabels = {
                [TITLE]: this.fieldTranslator(TITLE),
                [STATUS]: this.fieldTranslator(STATUS),
                [CHANNEL]: this.fieldTranslator(CHANNEL),
                [ID]: this.fieldTranslator(ID),
                [AD_ACCOUNT_ID]: this.fieldTranslator(AD_ACCOUNT_ID),
            };

            const fieldLabel = fieldLabels[by.field] || by.field;

            if (!by.level) {
                return fieldLabel;
            }

            return `${fieldLabel}: ${this.levelTranslator(by.field, by.level)}`;
        },
        ensureConditionBuilderVisible() {
            if (this.condition) {
                this.showConditionBuilder = true;
                return;
            }

            if (!this.effectiveBy || this.isLabelMode) {
                return;
            }

            const nextCondition = makeDefaultCondition(this.effectiveBy);

            if (!nextCondition) {
                return;
            }

            this.handleUpdate('condition', nextCondition);
            this.showConditionBuilder = true;
        },

        getSelectedGroupAssetIds() {
            const accounts = R.propOr(
                [],
                this.groupId,
                this.tableAdAccountsByGroupId
            );

            return R.uniq(
                accounts
                    .map(
                        (account) => account?.assetId || account?.asset?.assetId
                    )
                    .filter(Boolean)
            );
        },
        handleGroupChange(groupId) {
            const allowChannelBy = ['marketing', 'organic'].includes(groupId);
            const isCampaignBy =
                this.effectiveBy?.level === 'campaign' &&
                [TITLE, ID].includes(this.effectiveBy?.field);
            const shouldResetBy =
                (!allowChannelBy && this.effectiveBy?.field === CHANNEL) ||
                (groupId !== 'marketing' && isCampaignBy);
            const nextBy = shouldResetBy ? undefined : this.by;

            this.showPreviewValues = false;

            if (!groupId) {
                this.handleUpdatePatch({
                    groupId,
                    by: nextBy,
                    condition: undefined,
                    values: [],
                });
                return;
            }

            this.handleUpdatePatch({
                groupId,
                by: nextBy,
                condition: undefined,
                values: [],
            });
        },
        handleListTypeChange(nextSubType) {
            if (!nextSubType || nextSubType === this.subType) {
                return;
            }

            this.showPreviewValues = false;

            if (nextSubType === FILTER_WIDGET_LABEL_SUBTYPE) {
                this.handleUpdatePatch({
                    subType: FILTER_WIDGET_LABEL_SUBTYPE,
                    by: undefined,
                    groupId: undefined,
                    condition: undefined,
                    values: [],
                    availableLabels: this.availableLabels,
                });
                return;
            }

            this.handleUpdatePatch({
                subType: FILTER_WIDGET_FIELD_VALUE_SUBTYPE,
                availableLabels: null,
                groupId: this.availableChannelGroupIds.includes('marketing')
                    ? 'marketing'
                    : undefined,
                condition: undefined,
                values: [],
            });
        },
        handleByChange(by) {
            if (!by || !this.isSelectedGroupAvailable) {
                return;
            }

            if (R.equals(by, this.effectiveBy)) {
                return;
            }

            this.resetPreviewState();

            this.handleUpdatePatch({
                condition: undefined,
                by,
                subType: FILTER_WIDGET_FIELD_VALUE_SUBTYPE,
                availableLabels: null,
                values: [],
            });
        },
        handleConditionFieldChange(option) {
            if (!option) {
                return;
            }

            if (
                option.type === this.selectedConditionField?.type &&
                option.field === this.selectedConditionField?.field &&
                option.level === this.selectedConditionField?.level
            ) {
                return;
            }

            this.conditionValueVisible = false;
            this.conditionAdAccountList = [];

            this.handleUpdate('condition', {
                field: option.field,
                level: option.level,
                operator: this.getDefaultConditionOperator(option),
                values: undefined,
                not: false,
            });
        },
        getDefaultConditionOperator(option) {
            if (option?.field === ID && option?.level === 'campaign') {
                return DEFAULT_OPERATOR_MAP[ID];
            }

            return DEFAULT_OPERATOR_MAP[option.field];
        },
        handleConditionOperatorChange(value) {
            if (!value) {
                return;
            }

            const not = NOT_OPERATOR.includes(value);
            const operator = not ? COMPLEMENT_OPERATOR_MAP[value] : value;
            const baseCondition =
                this.condition || makeDefaultCondition(this.effectiveBy);

            this.handleUpdate('condition', {
                ...baseCondition,
                operator,
                not,
            });
        },
        handleConditionValuesChange(values) {
            const baseCondition =
                this.condition || makeDefaultCondition(this.effectiveBy);

            if (!baseCondition) {
                return;
            }

            this.handleUpdate('condition', {
                ...baseCondition,
                values: values?.length ? values : undefined,
            });
        },
        handleConditionDelete() {
            this.showConditionBuilder = false;
            this.showPreviewValues = false;
            this.conditionValueVisible = false;
            this.conditionAdAccountList = [];
            this.handleUpdate('condition', undefined);
        },
        handleFieldValueClear() {
            this.showConditionBuilder = false;
            this.showPreviewValues = false;
            this.conditionValueVisible = false;
            this.conditionAdAccountList = [];
            this.labelModeSnapshot = null;
            this.handleUpdatePatch({
                subType: FILTER_WIDGET_LABEL_SUBTYPE,
                availableLabels: [],
                groupId: undefined,
                by: undefined,
                condition: undefined,
                values: [],
            });
        },
        updateConditionDropdownPosition(wrapperEl) {
            const triggerRect = wrapperEl.getBoundingClientRect();
            if (!triggerRect) return;

            let top = triggerRect.bottom + DROPDOWN_GAP;

            if (top + DROPDOWN_HEIGHT > window.innerHeight) {
                top = Math.max(
                    DROPDOWN_GAP,
                    triggerRect.top - DROPDOWN_HEIGHT - DROPDOWN_GAP
                );
            }

            this.dropdownPosition = {
                top: `${top}px`,
            };
        },
        handleConditionDropdownClose(e) {
            const isEditArea = e.target.matches('.dashboard-drawer-edit-area');
            if (isEditArea && this.conditionValueVisible) {
                this.conditionValueVisible = false;
            }
        },
        handleConditionValueOutsideClick(e) {
            if (
                !e?.target?.closest(
                    '.condition-value-checkbox-dropdown-wrapper'
                )
            ) {
                this.conditionValueVisible = false;
            }
        },
        sanitizeConditionValuesForDatasourceScope() {
            if (!this.condition) {
                return;
            }

            const field = getRefinedField(this.condition);
            if (![CHANNEL, AD_ACCOUNT_ID].includes(field)) {
                return;
            }

            const values = getRefinedValues(this.condition || {});
            if (!values.length) {
                return;
            }

            /**
             * Validate against the UNSCOPED candidates. The scoped lists are
             * what the dropdown offers, but a value the teamspace merely hides
             * is not an invalid value — pruning on the scoped list deletes the
             * user's stored choice, and the scope is meant to hide, not delete.
             * Only genuinely gone datasources (deleted, moved out of the group)
             * are dropped here.
             */
            const validValues =
                field === AD_ACCOUNT_ID
                    ? this.conditionDataSourceListIgnoringScope.map(
                          R.prop('channelId')
                      )
                    : this.conditionChannelListIgnoringScope;
            const validValueSet = new Set(validValues.map(String));
            const nextValues = values.filter((value) =>
                validValueSet.has(String(value))
            );

            if (nextValues.length === values.length) {
                return;
            }

            /**
             * An empty `values` deletes the predicate outright, which drops the
             * filter and widens the exposure instead of narrowing it — the exact
             * opposite of what the scope is for. So keep the stored condition
             * untouched whenever nothing survives pruning.
             *
             * The scope no longer reaches this point at all — `validValues`
             * comes from the unscoped candidates — so what survives here is
             * the case this function is actually for: every stored value
             * points at a datasource that no longer exists anywhere.
             */
            if (!nextValues.length) {
                return;
            }

            this.conditionValueVisible = false;
            this.handleUpdate('condition', {
                ...this.condition,
                values: nextValues,
            });
        },
        handleConditionCheckboxInput(values) {
            this.handleConditionValuesChange(values);
            this.conditionValueVisible = false;
        },
        handleConditionAdAccountListUpdate(list) {
            this.conditionAdAccountList = list || [];
        },
        resetPreviewState() {
            this.showPreviewValues = false;
            this.debouncedFetchPreview?.cancel?.();
            this.clearPreviewLoading();
            this.clearPreviewResults();
        },
        handlePreviewValuesClick() {
            this.showPreviewValues = true;
            this.debouncedFetchPreview?.cancel?.();
            this.fetchPreview();
        },
        findConditionAdAccount(value) {
            return (
                (this.conditionAccountsIgnoringScope || []).find(
                    ({ channelId }) => channelId === value
                ) ||
                (this.conditionAdAccountList || []).find(
                    ({ channelId }) => channelId === value
                ) ||
                (this.tableAdAccounts || []).find(
                    ({ channelId }) => channelId === value
                )
            );
        },
        getConditionValueLabel(field, value) {
            if (field === CHANNEL) {
                const account =
                    (this.conditionAdAccountList || []).find(
                        ({ channelId, channel }) =>
                            channelId === value || channel === value
                    ) ||
                    (this.tableAdAccounts || []).find(
                        ({ channelId, channel }) =>
                            channelId === value || channel === value
                    );

                return this.translateOr(
                    `FILTERS.${CHANNEL}_option_${value}`,
                    account
                        ? this.userLang === 'ko'
                            ? account.displayChannelNameKR ||
                              account.displayChannelName
                            : account.displayChannelName
                        : refineRawText(value) || value
                );
            }

            if (field === AD_ACCOUNT_ID) {
                const account = this.findConditionAdAccount(value);

                return refineSourceName(account) || value;
            }

            return value;
        },
        getConditionValueIcon(field, value) {
            if (field === CHANNEL) {
                return this.channelIconWithAdverity(
                    refineChannelIconName(value)
                );
            }

            if (field === AD_ACCOUNT_ID) {
                const account = this.findConditionAdAccount(value) || {};
                const src = refineChannelLogoSrc(account);

                return src ? (
                    <S.ConditionValueLogo src={src} />
                ) : (
                    this.channelIconWithAdverity(refineChannel(account))
                );
            }

            return null;
        },
        getChannelOptionIcon(groupId, accountOverride) {
            const account =
                accountOverride ||
                R.head(R.propOr([], groupId, this.tableAdAccountsByGroupId)) ||
                {};

            if (groupId === 'marketing' || groupId === 'organic') {
                return (
                    <S.ChannelGroupLogo
                        src={`/static/assets/img/svg_icons/groupId_${groupId}.svg`}
                    />
                );
            }

            const src = refineChannelLogoSrc(account);

            if (src) {
                return <S.ChannelOptionLogo src={src} />;
            }

            return this.channelIconWithAdverity(
                refineChannel(account) || refineChannelIconName(groupId)
            );
        },
        renderChannelTrigger() {
            const hasValue = Boolean(
                this.groupId && this.isSelectedGroupAvailable
            );
            const label =
                this.selectedChannelLabel ||
                this.$t('NEW_DASHBOARD.dropdown_placeholder');
            const icon = hasValue
                ? this.getChannelOptionIcon(this.groupId)
                : null;

            return (
                <SelectedBox
                    placeholder={this.$t('NEW_DASHBOARD.dropdown_placeholder')}
                    selectedOption={label}
                    isOpen={this.channelVisible}
                    className={[
                        'channel-dropdown-selected-box',
                        { 'is-open': this.channelVisible },
                    ]}
                    onClick={() => {
                        this.channelVisible = !this.channelVisible;
                        this.byVisible = false;
                        this.nestedByVisible = {};
                        if (!this.channelVisible) {
                            this.nestedChannelVisible = {};
                        }
                    }}
                    customItemRenderer={() => (
                        <S.DropdownBoxTriggerValue>
                            {icon && (
                                <S.DropdownBoxTriggerIcon>
                                    {icon}
                                </S.DropdownBoxTriggerIcon>
                            )}
                            <span>{label}</span>
                        </S.DropdownBoxTriggerValue>
                    )}
                />
            );
        },
        renderConditionDropdownTrigger({
            selectedOption,
            isOpen,
            placeholder,
            customItemRenderer,
            onClick,
            className = '',
        }) {
            return (
                <S.ConditionTriggerWrapper>
                    <SelectedBox
                        className={className}
                        placeholder={placeholder}
                        selectedOption={selectedOption}
                        isOpen={isOpen}
                        nativeOnClick={onClick}
                        customItemRenderer={customItemRenderer}
                    />
                </S.ConditionTriggerWrapper>
            );
        },
        toggleConditionDropdown(dropdownKey) {
            const nextFieldVisible =
                dropdownKey === 'field' ? !this.conditionFieldVisible : false;
            const nextOperatorVisible =
                dropdownKey === 'operator'
                    ? !this.conditionOperatorVisible
                    : false;
            const nextStatusVisible =
                dropdownKey === 'status' ? !this.conditionStatusVisible : false;

            this.conditionFieldVisible = nextFieldVisible;
            this.conditionOperatorVisible = nextOperatorVisible;
            this.conditionStatusVisible = nextStatusVisible;
        },
        getConditionFieldDropdownTrigger() {
            return this.renderConditionDropdownTrigger({
                selectedOption: this.selectedConditionFieldLabel,
                isOpen: this.conditionFieldVisible,
                placeholder: this.$t('NEW_DASHBOARD.dropdown_placeholder'),
                onClick: () => this.toggleConditionDropdown('field'),
                className: [
                    'condition-field-selected-box',
                    { 'is-open': this.conditionFieldVisible },
                ],
            });
        },
        getConditionOperatorDropdownTrigger() {
            return this.renderConditionDropdownTrigger({
                selectedOption: this.selectedConditionOperator
                    ? this.$t(
                          `FILTERS.operator_${this.selectedConditionOperator}`
                      )
                    : '',
                isOpen: this.conditionOperatorVisible,
                placeholder: this.$t(
                    'NEW_DASHBOARD.filter_setting_panel_operator_placeholder'
                ),
                onClick: () => this.toggleConditionDropdown('operator'),
                className: [
                    'condition-operator-selected-box',
                    { 'is-open': this.conditionOperatorVisible },
                ],
            });
        },
        getConditionStatusDropdownTrigger() {
            const selectedStatus = this.selectedConditionValues[0];
            return this.renderConditionDropdownTrigger({
                selectedOption: selectedStatus
                    ? this.$t(`FILTERS.status_option_${selectedStatus}`)
                    : '',
                isOpen: this.conditionStatusVisible,
                placeholder: this.$t('NEW_DASHBOARD.dropdown_placeholder'),
                onClick: () => this.toggleConditionDropdown('status'),
            });
        },
        handleTopLevelChannelConfirm(item) {
            if (item?.children?.length) {
                this.nestedChannelVisible = {
                    [item.key]: true,
                };
                return;
            }

            this.handleGroupChange(item?.groupId);
            this.channelVisible = false;
            this.nestedChannelVisible = {};
        },
        handleNestedChannelConfirm(groupId) {
            this.handleGroupChange(groupId);
            this.channelVisible = false;
            this.nestedChannelVisible = {};
        },
        renderByTrigger() {
            return (
                <SelectedBox
                    className={[
                        'by-dropdown-selected-box',
                        { 'is-open': this.byVisible },
                    ]}
                    placeholder={this.$t('NEW_DASHBOARD.dropdown_placeholder')}
                    selectedOption={this.selectedByLabel}
                    isOpen={this.byVisible}
                    disabled={!this.isSelectedGroupAvailable}
                    onClick={() => {
                        if (!this.isSelectedGroupAvailable) {
                            return;
                        }

                        this.byVisible = !this.byVisible;
                        this.channelVisible = false;
                        this.nestedChannelVisible = {};
                        if (!this.byVisible) {
                            this.nestedByVisible = {};
                        }
                    }}
                />
            );
        },
        handleTopLevelByConfirm(item) {
            if (!item?.children?.length) {
                this.handleByChange(item?.by);
                this.byVisible = false;
                this.nestedByVisible = {};
                return;
            }

            this.nestedByVisible = {
                [item.key]: true,
            };
        },
        handleNestedByConfirm(by) {
            this.handleByChange(by);
            this.byVisible = false;
            this.nestedByVisible = {};
        },
        renderNestedByDropdown() {
            const activeKey = Object.keys(this.nestedByVisible).find(
                (key) => this.nestedByVisible[key]
            );
            const activeOption = this.groupedByOptions.find(
                (option) => String(option.key) === String(activeKey)
            );

            if (!this.byVisible || !activeOption?.children?.length) {
                return null;
            }

            const item$ = this.$refs[`byItem-${activeOption.key}`]?.$el;
            const parentOption$ = item$?.closest('.option-item');
            const dropdownWrapper$ = item$?.closest('.by-dropdown-menu');
            const parentOptionRect = parentOption$?.getBoundingClientRect();
            const dropdownRect = dropdownWrapper$?.getBoundingClientRect();
            const firstOptionRect = dropdownWrapper$
                ?.querySelector('.option-item')
                ?.getBoundingClientRect();

            if (!parentOptionRect || !dropdownRect) {
                return null;
            }

            const firstOptionOffset = firstOptionRect
                ? firstOptionRect.top - dropdownRect.top
                : 0;
            const nestedTop = parentOptionRect.top - firstOptionOffset;

            return (
                <portal to="panel_modal_second">
                    <S.ByNestedDropdown
                        class="nested-dropdown-wrapper ant-dropdown"
                        style={{
                            top: `${nestedTop}px`,
                            left: `${dropdownRect.right}px`,
                            width: `${dropdownRect.width}px`,
                        }}
                    >
                        <ul>
                            {activeOption.children.map((child) => (
                                <S.ByNestedOption
                                    key={`${child.by?.field}-${child.by?.level}`}
                                    isSelected={R.equals(
                                        child.by,
                                        this.effectiveBy
                                    )}
                                    onClick={() =>
                                        this.handleNestedByConfirm(child.by)
                                    }
                                >
                                    {child.text}
                                </S.ByNestedOption>
                            ))}
                        </ul>
                    </S.ByNestedDropdown>
                </portal>
            );
        },
        removeConditionValue(value) {
            const nextValues = R.without([value], this.selectedConditionValues);
            this.conditionValueVisible = false;
            this.handleConditionValuesChange(nextValues);
        },
        normalizeFilterText(text) {
            if (!text) {
                return '';
            }

            return String(text).replace(/\s+/g, '').toLowerCase();
        },
        renderMarketingDataSourceInput() {
            return (
                <S.ConditionCheckboxWrapper
                    ref="adAccountWrapper"
                    class="condition-value-checkbox-dropdown-wrapper"
                >
                    <SelectedBox
                        className={[
                            'filter-widget-gray-selected-box',
                            {
                                'is-open': this.conditionValueVisible,
                                'has-values':
                                    this.selectedConditionValues.length,
                            },
                        ]}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.dropdown_placeholder'
                        )}
                        selectedOption={
                            this.selectedConditionValues.length
                                ? this.selectedConditionValues
                                : undefined
                        }
                        customItemRenderer={(values) =>
                            this.renderConditionSelectedValues(
                                AD_ACCOUNT_ID,
                                values
                            )
                        }
                        isOpen={this.conditionValueVisible}
                        onClick={() => {
                            const nextVisible = !this.conditionValueVisible;
                            if (nextVisible) {
                                const wrapperEl =
                                    this.$refs.adAccountWrapper?.$el ??
                                    this.$refs.adAccountWrapper;
                                if (wrapperEl) {
                                    this.updateConditionDropdownPosition(
                                        wrapperEl
                                    );
                                }
                                this.channelVisible = false;
                                this.byVisible = false;
                            }
                            this.conditionValueVisible = nextVisible;
                        }}
                    />
                    {this.conditionValueVisible && (
                        <div
                            class="condition-value-checkbox-dropdown"
                            style={this.dropdownPosition}
                        >
                            <AdAccountCheckbox
                                options={this.conditionDataSourceList}
                                selectedItems={this.selectedConditionValues}
                                enableBlock={false}
                                normalizeText={this.normalizeFilterText}
                                allowEmptyValue={true}
                                onSubmit={(values) =>
                                    this.handleConditionCheckboxInput(values)
                                }
                            />
                        </div>
                    )}
                </S.ConditionCheckboxWrapper>
            );
        },
        renderConditionSelectedValues(field, values) {
            return (
                <S.ConditionSelectedItemWrapper>
                    {values.map((value) => {
                        const formattedValue = this.getConditionValueLabel(
                            field,
                            value
                        );
                        const icon = this.getConditionValueIcon(field, value);

                        return (
                            <S.ConditionSelectedItem>
                                <S.ConditionSelectedContent>
                                    {icon}
                                    <S.ConditionSelectedText class="adriel-ellipsis">
                                        {formattedValue}
                                    </S.ConditionSelectedText>
                                </S.ConditionSelectedContent>
                                <CloseIcon
                                    v-view-box
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.removeConditionValue(value);
                                    }}
                                />
                            </S.ConditionSelectedItem>
                        );
                    })}
                </S.ConditionSelectedItemWrapper>
            );
        },
        renderConditionStructuredInput(FilterComponent, field) {
            return (
                <S.ConditionCheckboxWrapper class="condition-value-checkbox-dropdown-wrapper">
                    <SelectedBox
                        className={[
                            'filter-widget-gray-selected-box',
                            {
                                'is-open': this.conditionValueVisible,
                                'has-values':
                                    this.selectedConditionValues.length,
                            },
                        ]}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.dropdown_placeholder'
                        )}
                        selectedOption={
                            this.selectedConditionValues.length
                                ? this.selectedConditionValues
                                : undefined
                        }
                        customItemRenderer={(values) =>
                            this.renderConditionSelectedValues(field, values)
                        }
                        isOpen={this.conditionValueVisible}
                        onClick={() => {
                            const nextVisible = !this.conditionValueVisible;
                            if (nextVisible) {
                                this.channelVisible = false;
                                this.byVisible = false;
                            }
                            this.conditionValueVisible = nextVisible;
                        }}
                    />
                    {this.conditionValueVisible && (
                        <FilterComponent
                            class="condition-value-checkbox-dropdown"
                            handleSubmit={({ value }) =>
                                this.handleConditionCheckboxInput(value || [])
                            }
                            selectedOption={this.selectedConditionValues}
                            enableBlock={false}
                            filterVisible={this.conditionValueVisible}
                            isNewFilterUI={true}
                        />
                    )}
                </S.ConditionCheckboxWrapper>
            );
        },
        renderConditionChannelInput() {
            const hasChannelOptions = this.conditionChannelList.length > 0;

            return (
                <S.ConditionCheckboxWrapper
                    ref="channelWrapper"
                    class="condition-value-checkbox-dropdown-wrapper"
                >
                    <SelectedBox
                        className={[
                            'filter-widget-gray-selected-box',
                            {
                                'is-open': this.conditionValueVisible,
                                'has-values':
                                    this.selectedConditionValues.length,
                            },
                        ]}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.dropdown_placeholder'
                        )}
                        selectedOption={
                            this.selectedConditionValues.length
                                ? this.selectedConditionValues
                                : undefined
                        }
                        customItemRenderer={(values) =>
                            this.renderConditionSelectedValues(CHANNEL, values)
                        }
                        isOpen={this.conditionValueVisible}
                        onClick={() => {
                            const nextVisible = !this.conditionValueVisible;
                            if (nextVisible) {
                                const wrapperEl =
                                    this.$refs.channelWrapper?.$el ??
                                    this.$refs.channelWrapper;
                                if (wrapperEl) {
                                    this.updateConditionDropdownPosition(
                                        wrapperEl
                                    );
                                }
                                this.channelVisible = false;
                                this.byVisible = false;
                            }
                            this.conditionValueVisible = nextVisible;
                        }}
                    />
                    {this.conditionValueVisible && (
                        <div
                            class="condition-value-checkbox-dropdown"
                            style={this.dropdownPosition}
                        >
                            <ChannelCheckbox
                                options={
                                    hasChannelOptions
                                        ? this.conditionChannelList
                                        : []
                                }
                                selectedItems={this.selectedConditionValues}
                                enableBlock={false}
                                normalizeText={this.normalizeFilterText}
                                isNewFilterUI={true}
                                allowEmptyValue={true}
                                onSubmit={(values) =>
                                    this.handleConditionCheckboxInput(values)
                                }
                            />
                        </div>
                    )}
                </S.ConditionCheckboxWrapper>
            );
        },
        renderConditionValueInput() {
            const refinedField =
                this.selectedConditionField?.field ||
                (this.condition ? getRefinedField(this.condition) : undefined);

            if (this.conditionValueInputType === INPUT_TYPES.DROPDOWN) {
                return (
                    <Dropdown
                        value={
                            this.selectedConditionValues[0] ? 'selected' : ''
                        }
                        options={this.statusValueOptions.map((value) => ({
                            value,
                            text: this.$t(`FILTERS.status_option_${value}`),
                        }))}
                        formatter={R.prop('text')}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.dropdown_placeholder'
                        )}
                        borderLess={false}
                        customStyles={CONDITION_DROPDOWN_STYLE}
                        visible={this.conditionStatusVisible}
                        dropdownTrigger={this.getConditionStatusDropdownTrigger()}
                        onVisibleChange={(visible) => {
                            this.conditionStatusVisible = visible;
                        }}
                        onInput={({ value }) => {
                            this.handleUpdate('condition', {
                                ...this.condition,
                                values: value?.value
                                    ? [value.value]
                                    : undefined,
                            });
                            this.conditionStatusVisible = false;
                        }}
                    />
                );
            }

            if (
                this.conditionValueInputType ===
                INPUT_TYPES.DROPDOWN_CHECKBOX_INPUT
            ) {
                if (refinedField === CHANNEL) {
                    return this.renderConditionChannelInput();
                }

                if (refinedField === AD_ACCOUNT_ID) {
                    return this.renderMarketingDataSourceInput();
                }
            }

            return (
                <S.ConditionMultiInputWrapper>
                    <MultiInputField
                        className="condition-multi-input-field"
                        values={this.selectedConditionValues}
                        placeholder={this.$t(
                            'NEW_DASHBOARD.multi_input_placeholder'
                        )}
                        onKeydown={(e) => {
                            const newValue = R.compose(
                                R.trim,
                                R.pathOr('', ['target', 'value'])
                            )(e);

                            if (
                                e.key === 'Enter' &&
                                !e.isComposing &&
                                newValue
                            ) {
                                const nextValues = [
                                    ...this.selectedConditionValues,
                                    newValue,
                                ];
                                this.handleConditionValuesChange(nextValues);
                            }
                        }}
                        onBlur={(e) => {
                            const newValue = R.compose(
                                R.trim,
                                R.pathOr('', ['target', 'value'])
                            )(e);

                            if (!newValue) {
                                return;
                            }

                            const nextValues = [
                                ...this.selectedConditionValues,
                                newValue,
                            ];
                            this.handleConditionValuesChange(nextValues);
                        }}
                        onDeleteIdx={(idx) => {
                            const nextValues = R.remove(
                                idx,
                                1,
                                this.selectedConditionValues
                            );
                            this.handleConditionValuesChange(nextValues);
                        }}
                    />
                </S.ConditionMultiInputWrapper>
            );
        },
        renderFieldValueEditor() {
            return (
                <S.FieldValueEditorWrapper>
                    <S.FieldValueEditorBody>
                        {!this.showConditionBuilder && (
                            <S.FieldValueActionButton
                                onClick={() => {
                                    this.ensureConditionBuilderVisible();
                                }}
                            >
                                <span>+</span>
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.add_condition'
                                )}
                            </S.FieldValueActionButton>
                        )}
                        {this.showConditionBuilder && (
                            <div>
                                <S.ConditionTitle>
                                    <S.ConditionTitleLeft>
                                        {this.$t(
                                            'NEW_DASHBOARD.dropdown_options_panel.condition_builder'
                                        )}
                                        <Tooltip
                                            overlayClassName="dropdown-options-tooltip"
                                            overlayStyle={{
                                                maxWidth: '234px',
                                                width: '234px',
                                            }}
                                            placement="top"
                                            title={this.$t(
                                                'NEW_DASHBOARD.dropdown_options_panel.condition_builder_tooltip'
                                            )}
                                        >
                                            <InfoIcon
                                                v-view-box
                                                class="info-icon"
                                            />
                                        </Tooltip>
                                    </S.ConditionTitleLeft>
                                    <S.ConditionDeleteButton
                                        onClick={this.handleConditionDelete}
                                    >
                                        {this.$t('COMMON.delete')}
                                    </S.ConditionDeleteButton>
                                </S.ConditionTitle>
                                <S.ConditionCard>
                                    <S.ConditionRow>
                                        <S.ConditionField>
                                            <Dropdown
                                                value={
                                                    this.selectedConditionField
                                                        ? 'selected'
                                                        : ''
                                                }
                                                options={this.conditionFieldOptions.map(
                                                    (option) => ({
                                                        value: option,
                                                        text: this.formatByOption({
                                                            type: 'field',
                                                            field: option.field,
                                                            level: option.level,
                                                        }),
                                                    })
                                                )}
                                                formatter={R.prop('text')}
                                                placeholder={this.$t(
                                                    'NEW_DASHBOARD.dropdown_placeholder'
                                                )}
                                                borderLess={false}
                                                customStyles={
                                                    CONDITION_DROPDOWN_STYLE
                                                }
                                                visible={
                                                    this.conditionFieldVisible
                                                }
                                                dropdownTrigger={this.getConditionFieldDropdownTrigger()}
                                                onVisibleChange={(visible) => {
                                                    this.conditionFieldVisible =
                                                        visible;
                                                }}
                                                onInput={({ value }) => {
                                                    this.handleConditionFieldChange(
                                                        value?.value
                                                    );
                                                    this.conditionFieldVisible = false;
                                                }}
                                            />
                                        </S.ConditionField>
                                        <S.ConditionField>
                                            <Dropdown
                                                value={
                                                    this
                                                        .selectedConditionOperator
                                                        ? 'selected'
                                                        : ''
                                                }
                                                options={this.conditionOperatorOptions.map(
                                                    (operator) => ({
                                                        value: operator,
                                                        text: this.$t(
                                                            `FILTERS.operator_${operator}`
                                                        ),
                                                    })
                                                )}
                                                formatter={R.prop('text')}
                                                placeholder={this.$t(
                                                    'NEW_DASHBOARD.filter_setting_panel_operator_placeholder'
                                                )}
                                                borderLess={false}
                                                customStyles={
                                                    CONDITION_DROPDOWN_STYLE
                                                }
                                                visible={
                                                    this
                                                        .conditionOperatorVisible
                                                }
                                                dropdownTrigger={this.getConditionOperatorDropdownTrigger()}
                                                onVisibleChange={(visible) => {
                                                    this.conditionOperatorVisible =
                                                        visible;
                                                }}
                                                onInput={({ value }) => {
                                                    this.handleConditionOperatorChange(
                                                        value?.value
                                                    );
                                                    this.conditionOperatorVisible = false;
                                                }}
                                            />
                                        </S.ConditionField>
                                    </S.ConditionRow>
                                    <S.ConditionValueRow>
                                        {this.renderConditionValueInput()}
                                    </S.ConditionValueRow>
                                </S.ConditionCard>
                            </div>
                        )}
                        {!this.showPreviewValues && (
                            <S.FieldValueActionButton
                                onClick={this.handlePreviewValuesClick}
                            >
                                <EyeIcon v-view-box class="action-icon" />
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.preview_values'
                                )}
                            </S.FieldValueActionButton>
                        )}
                        {this.showPreviewValues && this.renderPreviewCard()}
                    </S.FieldValueEditorBody>
                </S.FieldValueEditorWrapper>
            );
        },
        renderFieldValueFooter() {
            return (
                <S.CTAWrapper>
                    <S.CancelActionButton
                        onClick={() => {
                            if (this.isOptionsChanged) {
                                this.openDialog();
                            }
                            this.closePanel();
                        }}
                    >
                        {this.$t('COMMON.cancel')}
                    </S.CancelActionButton>
                    <ActionButton
                        disabled={!this.hasSelectedBy}
                        onClick={() => {
                            if (!this.hasSelectedBy) {
                                return;
                            }
                            this.closePanel();
                        }}
                    >
                        {this.$t('COMMON.apply')}
                    </ActionButton>
                </S.CTAWrapper>
            );
        },
        async fetchPreview({ offset = 0, append = false } = {}) {
            const basePayload = this.previewRequestPayload;

            if (!this.panelVisibility || !basePayload) {
                this.clearPreviewResults();
                return;
            }

            const requestId = this.previewRequestId + 1;
            const payload = { ...basePayload, offset };
            this.previewRequestId = requestId;
            this.setPreviewLoading({ append, loading: true });

            try {
                const result = await DashboardService.getListFilterPreview(
                    payload
                );

                if (!this.isLatestPreviewRequest(requestId)) {
                    return;
                }

                this.applyPreviewResult({ result, append });
            } catch (error) {
                if (!this.isLatestPreviewRequest(requestId) || append) {
                    return;
                }

                this.clearPreviewResults();
            } finally {
                if (this.isLatestPreviewRequest(requestId)) {
                    this.clearPreviewLoading();
                }
            }
        },
        isLatestPreviewRequest(requestId) {
            return this.previewRequestId === requestId;
        },
        setPreviewLoading({ append, loading }) {
            if (append) {
                this.previewLoadingMore = loading;
                return;
            }

            this.previewLoading = loading;
        },
        clearPreviewLoading() {
            this.previewLoading = false;
            this.previewLoadingMore = false;
        },
        clearPreviewResults() {
            this.previewValues = [];
            this.previewTotal = 0;
            this.previewHasMore = false;
        },
        applyPreviewResult({ result, append }) {
            const values = result?.values || [];
            this.previewValues = append
                ? [...this.previewValues, ...values]
                : values;
            this.previewTotal = result?.total || 0;
            this.previewHasMore = Boolean(result?.hasMore);
        },
        async fetchNextPreviewPage() {
            if (
                this.previewLoading ||
                this.previewLoadingMore ||
                !this.previewHasMore
            ) {
                return;
            }

            await this.fetchPreview({
                offset: this.previewValues.length,
                append: true,
            });
        },
        handlePreviewScroll(event) {
            const target = event.currentTarget;
            const scrollPosition = target.scrollTop + target.clientHeight;
            const loadMorePosition =
                target.scrollHeight - PREVIEW_SCROLL_THRESHOLD;
            const isNearBottom = scrollPosition >= loadMorePosition;

            if (isNearBottom) {
                this.fetchNextPreviewPage();
            }
        },
        renderPreviewCard() {
            const names = this.previewNames;

            return (
                <div>
                    <S.PreviewTitleRow>
                        <S.ConditionTitleLeft>
                            {this.$t(
                                'NEW_DASHBOARD.dropdown_options_panel.preview_title'
                            )}
                            <Tooltip
                                overlayClassName="dropdown-options-tooltip"
                                overlayStyle={{
                                    maxWidth: '234px',
                                    width: '234px',
                                }}
                                placement="top"
                                title={this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.preview_title_tooltip'
                                )}
                            >
                                <InfoIcon v-view-box class="info-icon" />
                            </Tooltip>
                        </S.ConditionTitleLeft>
                        <S.PreviewActions>
                            {this.previewLoading && <RingLoader size={16} />}
                            <S.PreviewRefreshButton
                                disabled={this.previewLoading}
                                onClick={() => this.fetchPreview()}
                            >
                                {this.$t('NEW_DASHBOARD.tooltips.refresh')}
                            </S.PreviewRefreshButton>
                        </S.PreviewActions>
                    </S.PreviewTitleRow>

                    <S.PreviewCard>
                        {names.length ? (
                            <S.PreviewList onScroll={this.handlePreviewScroll}>
                                {names.map((name) => (
                                    <S.PreviewItem key={name.key}>
                                        {name.icon && (
                                            <S.PreviewItemIcon>
                                                {name.icon}
                                            </S.PreviewItemIcon>
                                        )}
                                        <span>{name.text}</span>
                                    </S.PreviewItem>
                                ))}
                                {this.previewLoadingMore && (
                                    <S.PreviewLoadingMore>
                                        <RingLoader size={16} />
                                    </S.PreviewLoadingMore>
                                )}
                            </S.PreviewList>
                        ) : (
                            <div style={{ padding: '12px 16px 16px' }}>
                                <NoItemMessage>
                                    {this.$t(
                                        'NEW_DASHBOARD.dropdown_options_panel.no_preview_values'
                                    )}
                                </NoItemMessage>
                            </div>
                        )}
                    </S.PreviewCard>
                </div>
            );
        },
        renderListTypeRow() {
            if (!this.isFieldValueFilterWidgetEnabled) {
                return null;
            }

            return (
                <S.FieldRow class="full-width">
                    <S.FieldControl>
                        <S.ListTypeToggle>
                            <button
                                class={{ active: !this.isLabelMode }}
                                onClick={() =>
                                    this.handleListTypeChange(
                                        FILTER_WIDGET_FIELD_VALUE_SUBTYPE
                                    )
                                }
                            >
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.field_value_header'
                                )}
                            </button>
                            <button
                                class={{ active: this.isLabelMode }}
                                onClick={() =>
                                    this.handleListTypeChange(
                                        FILTER_WIDGET_LABEL_SUBTYPE
                                    )
                                }
                            >
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.label_header'
                                )}
                            </button>
                        </S.ListTypeToggle>
                    </S.FieldControl>
                </S.FieldRow>
            );
        },
        renderByRow() {
            return (
                <S.FieldRow>
                    <S.FieldLabel>
                        {this.$t('NEW_DASHBOARD.dropdown_options_panel.by')}
                    </S.FieldLabel>
                    <S.FieldControl>
                        <S.ByDropdownWrapper>
                            {this.renderByTrigger()}
                            <DefaultDropdownBox
                                selectedOption={this.effectiveBy}
                                width="100%"
                                showSelected={false}
                                appendToBody={false}
                                isVisible={this.byVisible}
                                optionList={this.groupedByOptions}
                                customCss={S.byDropdownCss}
                                className="by-dropdown-menu"
                                translator={R.prop('text')}
                                customItemRenderer={(item) => {
                                    const hasChildren =
                                        item?.children?.length > 0;

                                    return (
                                        <S.ByOptionItem
                                            ref={`byItem-${item.key}`}
                                        >
                                            <span>{item.text}</span>
                                            {hasChildren && (
                                                <NextIcon v-view-box />
                                            )}
                                        </S.ByOptionItem>
                                    );
                                }}

                                onConfirm={(value) =>
                                    this.handleTopLevelByConfirm(value || {})
                                }
                                onClickOutside={() => {
                                    this.byVisible = false;
                                    this.nestedByVisible = {};
                                }}
                            />
                            {this.renderNestedByDropdown()}
                        </S.ByDropdownWrapper>
                    </S.FieldControl>
                </S.FieldRow>
            );
        },
        renderSettingsHeader() {
            return (
                <S.SettingsWrapper>
                    {this.renderListTypeRow()}
                    {!this.isFieldValueFilterWidgetEnabled && (
                        <div>
                            <S.Description>
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.desc'
                                )}
                            </S.Description>
                            <S.LegacyNoteWrapper>
                                <S.LegacyNoteHeader>
                                    <S.LegacyNoteTitle>
                                        <BulletPointIcon fill="#5C7CF9" />
                                        {this.$t(
                                            'NEW_DASHBOARD.dropdown_options_panel.note.title'
                                        )}
                                    </S.LegacyNoteTitle>
                                </S.LegacyNoteHeader>
                                <S.LegacyNoteList>
                                    {this.$t(
                                        'NEW_DASHBOARD.dropdown_options_panel.note.contents'
                                    ).map((text) => (
                                        <S.LegacyNoteItem>
                                            {text}
                                        </S.LegacyNoteItem>
                                    ))}
                                </S.LegacyNoteList>
                            </S.LegacyNoteWrapper>
                        </div>
                    )}
                    {this.isFieldValueFilterWidgetEnabled && (
                        <NoteWrapper>
                            <InfoIcon v-view-box class="info-icon" />
                            <NoteText>
                                {this.$t(
                                    this.isLabelMode
                                        ? 'NEW_DASHBOARD.dropdown_options_panel.label_options_note'
                                        : 'NEW_DASHBOARD.dropdown_options_panel.field_value_options_note'
                                )}
                            </NoteText>
                        </NoteWrapper>
                    )}
                    {this.isLabelMode ? null : (
                        <div>
                            <S.SectionTitle>
                                {this.$t(
                                    'NEW_DASHBOARD.dropdown_options_panel.select_data'
                                )}
                            </S.SectionTitle>
                            <S.ChannelFieldCard>
                                <S.FieldRow>
                                    <S.FieldLabel>
                                        {this.$t(
                                            'NEW_DASHBOARD.dropdown_options_panel.select_channel'
                                        )}
                                    </S.FieldLabel>
                                    <S.FieldControl>
                                        <S.ChannelDropdownWrapper>
                                            {this.renderChannelTrigger()}
                                            <DefaultDropdownBox
                                                selectedOption={this.groupId}
                                                width="100%"
                                                showSelected={false}
                                                appendToBody={false}
                                                isVisible={this.channelVisible}
                                                optionList={this.channelOptions}
                                                customCss={S.channelDropdownCss}
                                                translator={R.prop('text')}
                                                customItemRenderer={(item) => {
                                                    const hasChildren =
                                                        item?.children?.length >
                                                        0;
                                                    const item$ =
                                                        this.$refs[
                                                            `channelItem-${item.key}`
                                                        ]?.$el;
                                                    const parentOption$ =
                                                        item$?.closest(
                                                            '.option-item'
                                                        );
                                                    const dropdownWrapper$ =
                                                        parentOption$?.closest(
                                                            '#commonDropboxWrapper'
                                                        );
                                                    const top =
                                                        parentOption$ &&
                                                        dropdownWrapper$
                                                            ? parentOption$.getBoundingClientRect()
                                                                  .top -
                                                              dropdownWrapper$.getBoundingClientRect()
                                                                  .top
                                                            : 0;

                                                    return (
                                                        <S.ChannelOptionItem
                                                            ref={`channelItem-${item.key}`}
                                                        >
                                                            {item?.Icon && (
                                                                <span class="channel-option-icon">
                                                                    {item.Icon}
                                                                </span>
                                                            )}
                                                            <span>
                                                                {item.text}
                                                            </span>
                                                            {hasChildren && (
                                                                <NextIcon
                                                                    v-view-box
                                                                />
                                                            )}
                                                            {hasChildren && (
                                                                <DefaultDropdownBox
                                                                    selectedOption={
                                                                        this
                                                                            .groupId
                                                                    }
                                                                    width="100%"
                                                                    showSelected={
                                                                        false
                                                                    }
                                                                    appendToBody={
                                                                        false
                                                                    }
                                                                    class="nested-dropdown-wrapper"
                                                                    customCss={S.getChannelNestedDropdownCss(
                                                                        top
                                                                    )}
                                                                    isVisible={
                                                                        this
                                                                            .nestedChannelVisible[
                                                                            item
                                                                                .key
                                                                        ]
                                                                    }
                                                                    optionList={
                                                                        item.children
                                                                    }
                                                                    translator={R.prop(
                                                                        'text'
                                                                    )}
                                                                    customItemRenderer={(
                                                                        child
                                                                    ) => (
                                                                        <S.ChannelOptionItem>
                                                                            {child?.Icon && (
                                                                                <span class="channel-option-icon">
                                                                                    {
                                                                                        child.Icon
                                                                                    }
                                                                                </span>
                                                                            )}
                                                                            <span>
                                                                                {
                                                                                    child.text
                                                                                }
                                                                            </span>
                                                                        </S.ChannelOptionItem>
                                                                    )}
                                                                    onConfirm={(
                                                                        value
                                                                    ) =>
                                                                        this.handleNestedChannelConfirm(
                                                                            value?.groupId
                                                                        )
                                                                    }
                                                                    onClickOutside={() => {
                                                                        this.nestedChannelVisible =
                                                                            {};
                                                                    }}
                                                                />
                                                            )}
                                                        </S.ChannelOptionItem>
                                                    );
                                                }}
                                                onConfirm={(value) =>
                                                    this.handleTopLevelChannelConfirm(
                                                        value || {}
                                                    )
                                                }
                                                onClickOutside={() => {
                                                    this.channelVisible = false;
                                                    this.nestedChannelVisible =
                                                        {};
                                                }}
                                            />
                                        </S.ChannelDropdownWrapper>
                                    </S.FieldControl>
                                </S.FieldRow>
                                {this.renderByRow()}
                            </S.ChannelFieldCard>
                        </div>
                    )}
                </S.SettingsWrapper>
            );
        },
        closePanel() {
            this.active = false;
            this.closeSecondPanel();
            // Normalize empty conditions (no values) to undefined
            if (this.condition && this.selectedConditionValues.length === 0) {
                this.handleUpdate('condition', undefined);
            }
        },
        attachBreakdownInfo(breakdown, labels) {
            const { id, name } = breakdown;

            return labels.map((label) => ({
                ...label,
                customBreakdownId: id,
                customBreakdownName: name,
            }));
        },
        normalizeBreakdownLabels(breakdown) {
            return this.attachBreakdownInfo(
                { id: breakdown.id, name: breakdown.name },
                breakdown.labels || []
            );
        },
        normalizeSelectedBreakdownLabels(breakdown) {
            return this.attachBreakdownInfo(
                { id: breakdown.id, name: breakdown.name },
                breakdown.labels || []
            );
        },
        setBreakdownLoadingState(id, isLoading) {
            const key = String(id);
            this.breakdownLabelLoadingMap = {
                ...this.breakdownLabelLoadingMap,
                [key]: isLoading,
            };
        },
        setBreakdownLoadedState(id) {
            const key = String(id);
            this.breakdownLabelLoadedMap = {
                ...this.breakdownLabelLoadedMap,
                [key]: true,
            };
        },
        setBreakdownLabelRequest(id, request) {
            const key = String(id);
            this.breakdownLabelRequestMap = {
                ...this.breakdownLabelRequestMap,
                [key]: request,
            };
        },
        clearBreakdownLabelRequest(id) {
            const key = String(id);
            const nextRequestMap = { ...this.breakdownLabelRequestMap };
            delete nextRequestMap[key];
            this.breakdownLabelRequestMap = nextRequestMap;
        },
        setBreakdownLabels(id, labels) {
            const key = String(id);
            this.breakdownLabelsById = {
                ...this.breakdownLabelsById,
                [key]: labels,
            };
        },
        setSelectedLabels(id, labels) {
            const key = String(id);
            this.selectedLabelsByBreakdownId = {
                ...this.selectedLabelsByBreakdownId,
                [key]: labels,
            };
        },
        setSearchResults(breakdowns) {
            const searchBreakdownLabelsById = (breakdowns || []).reduce(
                (acc, breakdown) => {
                    acc[String(breakdown.id)] =
                        this.normalizeBreakdownLabels(breakdown);
                    return acc;
                },
                {}
            );

            this.searchBreakdowns = breakdowns || [];
            this.searchBreakdownLabelsById = searchBreakdownLabelsById;
        },
        clearSearchResults() {
            this.searchBreakdowns = [];
            this.searchBreakdownLabelsById = {};
        },
        getSearchParams() {
            const { currentView } = this;
            if (checkIsHidden(currentView)) {
                return {};
            }

            return {
                viewId: R.prop('id', currentView),
                teamspaceId: R.path(['teamspace', 'id'], currentView),
            };
        },
        async performLabelSearch(query) {
            const requestId = this.searchRequestId + 1;
            this.searchRequestId = requestId;
            const params = this.getSearchParams();

            try {
                const breakdowns =
                    await DashboardService.searchCustomBreakdownLabels({
                        q: query,
                        ...params,
                    });

                if (this.searchRequestId !== requestId) {
                    return;
                }

                this.setSearchResults(
                    filterDimensionsByGroup(
                        breakdowns || [],
                        this.groupId,
                        this.tableAdAccountsByGroupId
                    )
                );
            } catch (error) {
                if (this.searchRequestId === requestId) {
                    this.clearSearchResults();
                }
            } finally {
                if (this.searchRequestId === requestId) {
                    this.isSearchLoading = false;
                }
            }
        },
        handleSearchQueryChange(value) {
            this.searchQuery = value;
            const trimmedQuery = value?.trim() || '';

            if (!trimmedQuery) {
                this.debouncedSearch?.cancel();
                this.clearSearchResults();
                this.isSearchLoading = false;
                return;
            }

            this.isSearchLoading = true;
            this.debouncedSearch(trimmedQuery);
        },
        async fetchBreakdownLabels(customBreakdownId) {
            if (!customBreakdownId) {
                return;
            }

            const key = String(customBreakdownId);
            const inFlightRequest = this.breakdownLabelRequestMap?.[key];
            if (inFlightRequest) {
                return inFlightRequest;
            }

            const request = (async () => {
                this.setBreakdownLoadingState(customBreakdownId, true);
                try {
                    const params = this.getSearchParams();
                    const labelIds = this.normalizedAvailableLabels
                        .filter(
                            (label) =>
                                !isFilterWidgetBreakdownLabel(label) &&
                                String(label?.customBreakdownId) ===
                                    String(customBreakdownId)
                        )
                        .map((label) => label?.id)
                        .filter(isValueExist);
                    const [breakdown, selectedLabels] = await Promise.all([
                        DashboardService.getCustomBreakdownById({
                            customBreakdownId,
                            ...params,
                        }),
                        DashboardService.resolveLabels({
                            labelIds,
                            ...params,
                        }),
                    ]);

                    if (!breakdown) {
                        this.setBreakdownLabels(customBreakdownId, []);
                        this.setSelectedLabels(customBreakdownId, []);
                        this.setBreakdownLoadedState(customBreakdownId);
                        return { labels: [] };
                    }

                    this.setBreakdownLabels(
                        customBreakdownId,
                        this.normalizeBreakdownLabels(breakdown)
                    );
                    this.setSelectedLabels(
                        customBreakdownId,
                        this.normalizeSelectedBreakdownLabels({
                            ...breakdown,
                            labels: selectedLabels,
                        })
                    );
                    this.setBreakdownLoadedState(customBreakdownId);
                    return breakdown;
                } catch (error) {
                    this.setBreakdownLabels(customBreakdownId, []);
                    this.setSelectedLabels(customBreakdownId, []);
                    this.setBreakdownLoadedState(customBreakdownId);
                    return { labels: [] };
                } finally {
                    this.setBreakdownLoadingState(customBreakdownId, false);
                    this.clearBreakdownLabelRequest(customBreakdownId);
                }
            })();

            this.setBreakdownLabelRequest(customBreakdownId, request);
            return request;
        },
        ensureSelectedBreakdownLabelsLoaded() {
            const { availableLabels } = this;

            const breakdownIds = R.uniq(
                (availableLabels || [])
                    .map(normalizeFilterWidgetAvailableLabel)
                    .filter((label) => !isFilterWidgetBreakdownLabel(label))
                    .map((label) => label?.customBreakdownId)
                    .filter(isValueExist)
            );

            breakdownIds.forEach((id) => {
                const key = String(id);
                if (
                    !this.breakdownLabelLoadedMap?.[key] &&
                    !this.breakdownLabelLoadingMap?.[key]
                ) {
                    this.fetchBreakdownLabels(id);
                }
            });
        },
        renderSecondPanelContent() {
            const {
                availableLabels,
                handleUpdateAvailableLabels,
                isOptionsChanged,
                displayBreakdownList,
                displayBreakdownLabelsById,
                breakdownLabelLoadedMap,
                breakdownLabelLoadingMap,
                categoryCheckStateById,
                searchQuery,
                isSearchLoading,
            } = this;

            const secondPanelContentProps = {
                props: {
                    availableLabels: this.normalizedAvailableLabels,
                    handleUpdateAvailableLabels,
                    breakdownList: displayBreakdownList,
                    breakdownLabelsById: displayBreakdownLabelsById,
                    allBreakdownLabelsById: this.breakdownLabelsById,
                    breakdownLabelLoadedMap,
                    breakdownLabelLoadingMap,
                    categoryCheckStateById,
                    handleFetchBreakdownLabels: (id) =>
                        this.fetchBreakdownLabels(id),
                    searchQuery,
                    isSearchLoading,
                    handleSearchQueryChange: this.handleSearchQueryChange,
                    handleCancel: () => {
                        if (isOptionsChanged) {
                            this.openDialog();
                        }
                        this.closePanel();
                    },
                    handleSubmit: this.closePanel,
                },
            };

            if (!this.isLabelMode) {
                return (
                    <S.ContentWrapper>
                        {this.renderSettingsHeader()}
                        {this.hasSelectedBy ? (
                            <div style="flex:1; min-height:0; display:flex; flex-direction:column; margin-top:16px;">
                                {this.renderFieldValueEditor()}
                            </div>
                        ) : (
                            <div style="flex:1; min-height:0;" />
                        )}
                        {this.renderFieldValueFooter()}
                    </S.ContentWrapper>
                );
            }

            return (
                <div style="display:flex; flex-direction:column; height:100%; min-height:0;">
                    {this.renderSettingsHeader()}
                    {this.isFieldValueFilterWidgetEnabled && <S.Divider />}
                    <div style="flex:1; min-height:0; display:flex; flex-direction:column;">
                        <SecondPanelContent {...secondPanelContentProps} />
                    </div>
                </div>
            );
        },
        renderChildren() {
            const { availableLabels, cursor, getLabelById } = this;

            if (!this.hasSelectedBy) {
                return (
                    <NoItemMessage>
                        {this.$t(
                            'NEW_DASHBOARD.dropdown_options_panel.no_filter_selected'
                        )}
                    </NoItemMessage>
                );
            }

            if (!this.isLabelMode) {
                return (
                    <S.FieldValueListWrapper>
                        <S.FieldValueSummaryWrapper>
                            <S.ItemBox dragCursor="default">
                                <div class="item-text adriel-ellipsis">
                                    {this.fieldValueSummaryLabel}
                                </div>
                                <CloseIcon
                                    class="close"
                                    v-view-box
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        this.handleFieldValueClear();
                                    }}
                                ></CloseIcon>
                            </S.ItemBox>
                        </S.FieldValueSummaryWrapper>
                    </S.FieldValueListWrapper>
                );
            }

            if (!isValueExist(availableLabels) || this.selectedCount === 0) {
                return (
                    <NoItemMessage>
                        {this.$t(
                            'NEW_DASHBOARD.dropdown_options_panel.no_filter_selected'
                        )}
                    </NoItemMessage>
                );
            }

            const normalizedAvailableLabels = this.normalizedAvailableLabels;
            const breakdownList = normalizedAvailableLabels
                .filter(isFilterWidgetBreakdownLabel)
                .filter((label) => this.breakdownById?.[String(label.id)]);
            const labelList = normalizedAvailableLabels
                .filter((label) => !isFilterWidgetBreakdownLabel(label))
                .filter((label) => this.getLabelById(label.id));

            const renderItem = (availableLabel) => {
                const isBreakdownChip =
                    isFilterWidgetBreakdownLabel(availableLabel);
                const label = isBreakdownChip
                    ? this.breakdownById?.[String(availableLabel.id)]
                    : getLabelById(availableLabel.id);

                if (!isValueExist(label)) {
                    return null;
                }

                const breakdownName =
                    availableLabel?.customBreakdownName ||
                    this.breakdownById?.[
                        String(availableLabel?.customBreakdownId)
                    ]?.name;
                const name =
                    !isBreakdownChip && breakdownName
                        ? `${label.name} (${breakdownName})`
                        : label.name;
                const labelKey =
                    getFilterWidgetAvailableLabelKey(availableLabel);

                return (
                    <S.ItemBox
                        key={labelKey}
                        dragCursor={cursor}
                        data-name={name}
                        isBreakdownChip={isBreakdownChip}
                    >
                        <MoveIcon class="move" v-view-box />
                        <div class="item-text adriel-ellipsis">{name}</div>
                        <CloseIcon
                            class="close"
                            v-view-box
                            onClick={(e) => {
                                e.stopPropagation();
                                this.handleUpdateAvailableLabels(
                                    normalizedAvailableLabels.filter(
                                        (l) =>
                                            getFilterWidgetAvailableLabelKey(
                                                l
                                            ) !== labelKey
                                    )
                                );
                            }}
                        ></CloseIcon>
                    </S.ItemBox>
                );
            };

            const reorderGroup = ({ list, oldIndex, newIndex }) => {
                const reorderedList = changeOrder({
                    oldIndex,
                    newIndex,
                    value: list,
                });
                const isBreakdownGroup = list.every(
                    isFilterWidgetBreakdownLabel
                );
                let groupIndex = 0;

                return normalizedAvailableLabels.map((item) => {
                    if (
                        isFilterWidgetBreakdownLabel(item) === isBreakdownGroup
                    ) {
                        const reorderedItem = reorderedList[groupIndex];
                        groupIndex += 1;
                        return reorderedItem;
                    }

                    return item;
                });
            };

            const renderDraggableList = (list, groupName) => {
                if (!isValueExist(list)) {
                    return null;
                }

                return (
                    <Draggable
                        value={[...list]}
                        animation={200}
                        group={groupName}
                        ghostClass="ghost"
                        class="drag-area"
                        forceFallback={true}
                        on={{
                            start: () => (this.drag = true),
                            end: ({ oldIndex, newIndex }) => {
                                this.handleUpdateAvailableLabels(
                                    reorderGroup({
                                        list,
                                        oldIndex,
                                        newIndex,
                                    })
                                );
                                this.drag = false;
                            },
                        }}
                    >
                        {list.map(renderItem)}
                    </Draggable>
                );
            };

            return (
                <S.ListWrapper>
                    {isValueExist(labelList) && (
                        <S.ListSection>
                            {renderDraggableList(labelList, 'dropdown-labels')}
                        </S.ListSection>
                    )}
                    {isValueExist(breakdownList) && (
                        <S.ListSection withBorder={isValueExist(labelList)}>
                            {renderDraggableList(
                                breakdownList,
                                'dropdown-breakdowns'
                            )}
                        </S.ListSection>
                    )}
                </S.ListWrapper>
            );
        },
        openDialog() {
            this.showDialog = true;
        },
        closeDialog() {
            this.showDialog = false;
        },
        async resetOptions() {
            const { originalOptions, handleUpdatePatch } = this;

            // No snapshot means the panel-open watcher never ran; patching
            // would overwrite every saved option with undefined.
            if (R.isEmpty(originalOptions)) {
                return;
            }

            const { availableLabels, subType, groupId, by, condition, values } =
                originalOptions;

            handleUpdatePatch({
                availableLabels,
                subType,
                groupId,
                by,
                condition,
                values,
            });
        },
        hasUnsavedOpenPanel() {
            return this.active && this.isOptionsChanged;
        },
        requestCloseWithConfirm(onProceed) {
            this.pendingCloseProceed = onProceed;
            this.openDialog();
        },
        resolvePendingClose() {
            const { pendingCloseProceed } = this;
            if (!pendingCloseProceed) return;

            this.pendingCloseProceed = null;
            pendingCloseProceed();
        },
        handleDialogConfirm() {
            const { closeDialog, closePanel } = this;
            closeDialog();
            closePanel();
            this.resolvePendingClose();
        },
        async handleDialogCancel() {
            const { isOptionsChanged, resetOptions, closeDialog, closePanel } =
                this;
            if (isOptionsChanged) {
                await resetOptions();
            }

            closeDialog();
            closePanel();
            this.resolvePendingClose();
        },
        getDialogProps() {
            const { showDialog, handleDialogConfirm, handleDialogCancel } =
                this;
            const dialogProps = {
                props: {
                    active: showDialog,
                    backdrop: true,
                    child: (
                        <div>{this.$t('NEW_DASHBOARD.ask_apply_change')}</div>
                    ),
                    emitCancelOnClickOutside: true,
                },
                on: {
                    confirm: handleDialogConfirm,
                    cancel: handleDialogCancel,
                    'update:active': (val) => {
                        this.showDialog = val;
                    },
                },
            };
            return dialogProps;
        },
        getLabelById(id) {
            const { labelsById } = this;
            return labelsById?.[id];
        },
    },
    render() {
        const {
            wrapOptions,
            secondPanelOutsideClickActive,
            isOptionsChanged,
            openDialog,
            renderChildren,
            renderSecondPanel,
            renderSecondPanelContent,
            getDialogProps,
            selectedCount,
            maxSelectedLabels,
        } = this;

        const dialogProps = getDialogProps();
        const showSelectedCountBadge = this.isLabelMode;

        return (
            <div>
                {renderSecondPanel({
                    title: this.$t(
                        'NEW_DASHBOARD.dropdown_options_panel.title'
                    ),
                    content: renderSecondPanelContent(),
                    closeOutside: secondPanelOutsideClickActive,
                    onClose: isOptionsChanged
                        ? openDialog
                        : () => (this.active = false),
                })}
                {wrapOptions({
                    children: renderChildren(),
                    title: (
                        <S.TitleWrapper>
                            <span>
                                {this.$t('NEW_DASHBOARD.dropdown_options')}
                            </span>
                            {showSelectedCountBadge && (
                                <S.SelectedCountBadge>
                                    {this.$t(
                                        'NEW_DASHBOARD.dropdown_options_panel.selected_count_prefix'
                                    )}
                                    <S.SelectedCountNumber>
                                        {selectedCount}
                                    </S.SelectedCountNumber>
                                    {this.wrapTooltip({
                                        visible: true,
                                        overlayClassName:
                                            'dropdown-options-tooltip selected-count-tooltip',
                                        content: (
                                            <InfoIcon
                                                v-view-box
                                                class="selected-count-info-icon"
                                            />
                                        ),
                                        title: this.$t(
                                            'NEW_DASHBOARD.dropdown_options_panel.selected_count_tooltip',
                                            {
                                                count: maxSelectedLabels.toLocaleString(),
                                            }
                                        ),
                                    })}
                                </S.SelectedCountBadge>
                            )}
                        </S.TitleWrapper>
                    ),
                    icon: <FilterIcon v-view-box class="metric-icon" />,
                    hasEditBtn: true,
                    onClick: () => (this.active = true),
                    disableClick: this.active,
                })}
                <portal to="panel_modal_second">
                    <Dialog {...dialogProps} />
                </portal>
            </div>
        );
    },
};
